import { returnAllTradeDetailsFromGenericParams } from "@/lib/agGridColDefs/colDefGlobalHelpers";
import tradeDataStore from "@/store/tradeDataStore";
import { useTheme } from "next-themes";
import { formatSettlementDate } from "./settlementDateFormatter";
import { isSettlementDateEditable } from "./settlementDateHelpers";

/**
 * SettlementDateCellRenderer
 *
 * Displays settlement date with real-time Zustand updates for editability styling.
 * Replaces the cellClass callback approach which required redrawRows() to re-evaluate,
 * causing a visible UI flash.
 *
 * cellRendererParams:
 * - statusField: "status" (outright ER) | "statusER" (non-outright ER) | undefined (read-only leg)
 * - fullTradeData: the trade object
 *
 * Works with settlementDateValueFormatter for copy/paste support.
 */
const SettlementDateCellRenderer = (params: any) => {
  const { theme } = useTheme();
  const { fullTradeData } = returnAllTradeDetailsFromGenericParams(params);

  // Subscribe to Zustand store for reactive updates
  const currentTradeData = tradeDataStore((state) => state.tradeData);
  const thisTrade =
    currentTradeData.find((trade) => trade.esid == fullTradeData.esid) ??
    fullTradeData;

  // Resolve live status and editability (only for ER-level with statusField)
  let editable = false;

  const liveStatus = thisTrade.status;
  const role = thisTrade.role;

  editable = isSettlementDateEditable(liveStatus, role);

  const formattedDate = formatSettlementDate(params.value);

  function editableStyle() {
    if (editable && theme == "light") {
      return "inputCellOtherLight roundedInputCell";
    } else if (editable && theme == "dark") {
      return "inputCellOtherDark roundedInputCell";
    }
  }

  return (
    <div
      data-testid="SettlementDateCellContainer"
      // id="SettlementDateCellContainer"
      className={`${editableStyle()}`}
    >
      {formattedDate}
    </div>
  );
};

export default SettlementDateCellRenderer;
